export const ROUTE_LEG_FIELDS = ["altitude", "trackTrue", "variation"];

const mapLegs = (routeLegs, old = []) =>
  (routeLegs || []).map((l, i) => {
    const prev = old[i] || old[old.length - 1] || {};
    return {
      name: l.name, altitude: l.altitude, trackTrue: l.trackTrue, distance: l.distance,
      variation: l.variation || 0, alternate: l.alternate || "",
      frequencies: Array.isArray(l.frequencies) ? l.frequencies : [],
      windDir: prev.windDir ?? 0, windSpeed: prev.windSpeed ?? 0, deviation: prev.deviation ?? 0,
    };
  });

// Route = source de vérité pour la géométrie ; le briefing garde ses propres vents/déviation par branche.
export function mergeRouteIntoBriefing(briefing, route) {
  const roundTrip = !!route.roundTrip;
  return {
    ...briefing,
    roundTrip,
    legs: mapLegs(route.legs, briefing.legs),
    returnLegs: roundTrip ? mapLegs(route.returnLegs, briefing.returnLegs || briefing.legs) : [],
    departure: route.departure || "",
    arrival: route.arrival || "",
  };
}

// Codes OACI : départ, dégagements (aller et retour), arrivée.
export function terrainCodes(b) {
  const list = [b.departure, ...(b.legs || []).map((l) => l.alternate), ...(b.returnLegs || []).map((l) => l.alternate), b.arrival];
  return [...new Set(list.map((c) => (c || "").trim().toUpperCase()).filter(Boolean))];
}

// Retour généré depuis l'aller : points inversés, Rv + 180°, dernier point = départ.
export function reverseLegs(legs, departure) {
  const n = legs.length;
  return legs.map((_, j) => {
    const src = legs[n - 1 - j];
    return {
      ...src,
      name: j === n - 1 ? departure || "Départ" : legs[n - 2 - j]?.name || "",
      trackTrue: ((Number(src.trackTrue) || 0) + 180) % 360,
      frequencies: [...(src.frequencies || [])],
    };
  });
}
